import { axiosWithAuth } from '../../utilities';

const baseUrl = `${process.env.CARVANA_APP_MYCARS_API_URL}/v3`;

export default class MyCarsApi {
  static getPurchases() {
    const endpoint = `${baseUrl}/purchases`;
    return axiosWithAuth({ timeout: 20000 }).get(endpoint);
  }
}
